import { resolveConfirm, useConfirmRequest } from '@shared-ui/platform/confirm-dialog/store'
import { useSheetPortals } from '@web/hooks/ui/use-sheet-portals'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import styles from './styles.module.css'

// Единственный хост, монтируется в корне веб-приложения. Рисует активный confirm-запрос
// из стора как модалку в стиле iOS-алерта
export function ConfirmDialogHost() {
  const request = useConfirmRequest()
  const { portalContainer, useBodyPortal } = useSheetPortals()

  useEffect(() => {
    if (!request) return

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') resolveConfirm(false)

      if (event.key === 'Enter') resolveConfirm(true)
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [request])

  if (!request) return null

  const { title, message, confirmText = 'OK', cancelText = 'Cancel', destructive } = request
  const portalTarget = portalContainer ?? document.body
  const overlayClassName = useBodyPortal ? `${styles.overlay} ${styles.overlayWideDesktop}` : styles.overlay

  return createPortal(
    <div className={overlayClassName} role="alertdialog" aria-modal="true">
      <div className={styles.dialog}>
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          {!!message && <div className={styles.message}>{message}</div>}
        </div>
        <div className={styles.buttons}>
          <button type="button" className={styles.button} onClick={() => resolveConfirm(false)}>
            {cancelText}
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.confirm} ${destructive ? styles.destructive : ''}`}
            onClick={() => resolveConfirm(true)}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    portalTarget,
  )
}
